import { forwardRef, createElement } from 'react';
import PropTypes from 'prop-types';
import { icons } from 'data/icons';
import { env } from 'env';

const Icon = forwardRef((props, forwardedRef) => {
  const { name, width: svgWidth, height: svgHeight, ...rest } = props;
  const icon = (window.__P81__?.icons || icons)[name];
  if (!icon) {
    if (env.NODE_ENV === 'development') {
      console.error(`Icon with name ${name} not found`);
    }
    return null;
  }

  let [width, height, paths] = icon;
  return createElement(
    'svg',
    {
      ref: forwardedRef,
      width: svgWidth,
      height: svgHeight,
      viewBox: `0 0 ${width} ${height}`,
      ...rest
    },
    paths.map((d, index) =>
      createElement('path', {
        key: index,
        fill: 'currentColor',
        fillRule: 'evenodd',
        d
      })
    )
  );
});

Icon.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  name: PropTypes.string,
  className: PropTypes.string
};

Icon.displayName = 'Icon';

export default Icon;
